import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const ThemeFeatureCard = ({children, title, description}) => {
  return (
    <Wrapper>
      <Icon>{children}</Icon>
      <Content>
        <Title>{title}</Title>
        {description && <Description>{description}</Description>}
      </Content>
    </Wrapper>
  )
}

export default ThemeFeatureCard

ThemeFeatureCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
}

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 50px auto;
  grid-gap: 30px;
  padding: 24px 30px;
  border: 1px solid ${props => props.theme.color.grey.darker};
  border-radius: 8px;
  align-items: center;
  min-height: 155px;
`

const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

const Content = styled.div``

const Title = styled.h3`
  font-size: 1.8rem;
  margin: 0 0 8px;
`

const Description = styled.p`
  font-size: 1.6rem;
  color: ${props => props.theme.color.text.lightest};
`
